import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filter',
})
export class FilterPipe implements PipeTransform {

    transform<T extends object>(values: T[], value: any, field?: string, not?: boolean, trigger?: any): T[] {
        if (!value) {
            return values;
        }
        if (values) {
            return values.filter(p => {
                let useField: unknown = p;
                if (field) {
                    useField = (p as Record<string, unknown>)[field];
                }
                const fieldValue = typeof useField === 'function'
                    ? (useField as () => unknown)()
                    : useField;

                const isMatch = Array.isArray(value)
                    ? value.includes(fieldValue)
                    : fieldValue == value;

                if (not) {
                    return isMatch === false;
                }

                return isMatch;
            });
        }
        return null;
    }

}
